module.exports = __webpack_public_path__ + "static/analytics-09455fc60b17a5885d32b0321c9c0c7a.png";